import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=0f0d4b34"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports